export default __webpack_public_path__ + "static/media/img_step_lucia08_w.19962ad2.png";